import { IAuthorizationService } from '../services';

export class StateControllerBase {
    constructor(private _authorizationService: IAuthorizationService) {
    }

    canEdit() {
        return this._authorizationService.canEdit();
    }
}